import { memo } from "react";
import Search from "../Search";
import { Prefixes } from "../../../../Tools/ProjectX";
import clsx from "clsx";
import styles from "../dialogStyles.module.css";

interface Props {
  props: {
    groupId?: string;
    module?: Prefixes;
    objType?: string;
    setSearchResult?: (id: string) => void;
  };
}

/**
 * Устанавливает условие перерисовки компонента сравнивая свойства
 * @returns Возвращает false если нужно перерисовать компонент
 */
const propsEqual = (prev: Props, next: Props) => {
  if (prev.props.groupId !== next.props.groupId) return false;
  return true;
};

/**
 * Возвращает мемоизированый компонент поиска меняющийся только при изменении groupId
 * @returns Возвращает компонент для вкладки поиск
 */
const ParamsSearchForTabs = memo((props: Props) => {
  const {
    props: { groupId, module, objType, setSearchResult },
  } = props;

  return (
    <div id={"item_Search"} className={clsx(styles.fullDialogSpaceContainer)}>
      {groupId && module && <Search GroupId={groupId} Module={module} ObjType={objType} returnFunc={setSearchResult} />}
    </div>
  );
}, propsEqual);

export default ParamsSearchForTabs;
